import React from "react";
import { Dropdown } from "primereact/dropdown";
import Snippet from "../SnippetIcon/Snippet";
import InlineError from "../InlineError/InlineError";
import {
  FIELD_DEFAULT_VARIANT,
  FIELD_DROPDOWN,
  INPUT_FIELD_VARIANT_CLASSES,
  resolveFieldVariant,
} from "./fieldSystem";

const DROPDOWN_CHROME =
  "field-dropdown p-dropdown-trigger-custom flex items-center !pr-10";

const SURFACE_CLASSES = {
  default: "bg-white field-dropdown-standard",
  muted: "tp-fields custom-dropdown-field !border-none !bg-mistygray field-dropdown-muted",
};

const toDropdownVariantClass = (inputClass) =>
  `${inputClass.replace(/\bblock\b/, "flex items-center")} ${DROPDOWN_CHROME}`;

const DROPDOWN_VARIANT_CLASSES = Object.fromEntries(
  Object.entries(INPUT_FIELD_VARIANT_CLASSES).map(([key, value]) => [
    key,
    toDropdownVariantClass(value),
  ])
);

const getDefaultAppendTo = (surface, appendTo) => {
  if (appendTo !== undefined) return appendTo;
  if (surface === "muted") return null;
  return typeof document !== "undefined" ? document.body : null;
};

const FieldDropdown = ({
  className = "",
  wrapperClassName = "",
  variant = FIELD_DEFAULT_VARIANT.dropdown,
  surface = "default",
  fullWidth,
  label,
  snippet,
  SnippetText,
  star,
  error,
  panelClassName = FIELD_DROPDOWN.panelClassName,
  placeholder,
  showChevron = true,
  onBlur,
  appendTo,
  ...dropdownProps
}) => {
  const useFullWidth = fullWidth ?? surface === "default";
  const effectiveVariant = resolveFieldVariant(variant, useFullWidth);
  const resolvedKey = DROPDOWN_VARIANT_CLASSES[effectiveVariant]
    ? effectiveVariant
    : resolveFieldVariant(FIELD_DEFAULT_VARIANT.dropdown, useFullWidth);
  const surfaceClass = SURFACE_CLASSES[surface] || SURFACE_CLASSES.default;
  const fieldClass =
    `${DROPDOWN_VARIANT_CLASSES[resolvedKey]} ${surfaceClass} ${className}`.trim();
  const wrapperClass =
    `${FIELD_DROPDOWN.wrapperClassName} relative w-full min-w-0 ${wrapperClassName}`.trim();
  const appendTarget = getDefaultAppendTo(surface, appendTo);

  return (
    <div className="flex w-full min-w-0 flex-col">
      {(label || SnippetText || snippet || star) && (
        <Snippet
          variant="label"
          label={label}
          text={SnippetText}
          snippet={snippet}
          star={star}
        />
      )}
      <div className={wrapperClass}>
        <Dropdown
          {...dropdownProps}
          placeholder={placeholder}
          className={fieldClass}
          panelClassName={panelClassName}
          onBlur={onBlur}
          appendTo={appendTarget}
        />
        {showChevron && (
          <i
            className="fi fi-rs-angle-down custom-dropdown-icon text-base text-offblack"
            aria-hidden
          />
        )}
      </div>
      <InlineError message={error} />
    </div>
  );
};

export default FieldDropdown;
